class FaqAccordion extends HTMLElement {
  constructor() {
    super();
    this.items = Array.from(this.querySelectorAll('[data-faq-item]'));

    this.items.forEach((item) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        // Close all items (single-open accordion behavior)
        this.items.forEach((otherItem) => {
          otherItem.classList.remove('is-open');
          const otherTrigger = otherItem.querySelector('[data-faq-trigger]');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
}

customElements.define('faq-accordion', FaqAccordion);
